import React, { Component, Fragment } from 'react';
import { Grid, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router';
import moment from 'moment';

import {
  DatePickerField,
  InputField,
  SelectField,
} from 'Common/SemanticWrapper';
import { LETTER_HISTORY_REPORT_FREE_AND_REDUCED_MODE_FORM_NAME } from 'Common/FormEnum';
import { LetterHistoryReportFieldEnum as Fields } from 'Common/FieldEnum';
import { FreeAndReducedModeLetterTypes, SortByOptions } from '../constants';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';

class LetterHistoryReportFormContainer extends Component {
  state = { isOnlyCEPSelected: false };

  render() {
    const { loading, changeFormValue } = this.props;
    const { isOnlyCEPSelected } = this.state;

    const sortOptions = isOnlyCEPSelected
      ? SortByOptions.slice(1, 4)
      : SortByOptions;

    return (
      <Fragment>
        <Form name={LETTER_HISTORY_REPORT_FREE_AND_REDUCED_MODE_FORM_NAME}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={5}>
                <Field
                  label={'From Date'}
                  name={Fields.FromDate}
                  component={DatePickerField}
                  type="text"
                  openToDate={moment()}
                  maxDate={moment()}
                  disabled={loading}
                />
              </Grid.Column>
              <Grid.Column width={5}>
                <Field
                  label={'To Date'}
                  name={Fields.ToDate}
                  component={DatePickerField}
                  type="text"
                  openToDate={moment()}
                  maxDate={moment()}
                  disabled={loading}
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={10}>
                <Field
                  multiple
                  selectAllButton
                  selectNoneButton
                  label={'Letter Types'}
                  name={Fields.LetterTypes}
                  component={SelectField}
                  onChange={(e, newTemplates) => {
                    if (newTemplates.length === 1 && newTemplates[0] === 'C') {
                      this.setState({ isOnlyCEPSelected: true });
                      changeFormValue(Fields.SortBy, 'alpha');
                    } else if (isOnlyCEPSelected) {
                      this.setState({ isOnlyCEPSelected: false });
                      changeFormValue(Fields.SortBy, 'family-number');
                    }
                  }}
                  options={FreeAndReducedModeLetterTypes}
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={6}>
                <Field
                  label={'Filter By Family Number'}
                  name={Fields.FamilyNumber}
                  component={InputField}
                  type="number"
                  disabled={isOnlyCEPSelected}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column className="field">
                <label className={'p-b-0 p-t-0'}>Sort By</label>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <ReduxFormButtonGroup
                  formName={
                    LETTER_HISTORY_REPORT_FREE_AND_REDUCED_MODE_FORM_NAME
                  }
                  fieldName={Fields.SortBy}
                  options={sortOptions}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Fragment>
    );
  }
}

const validate = values => {
  const errors = {};

  if (!moment(values[Fields.FromDate]).isValid()) {
    errors[Fields.FromDate] = 'Enter a valid From Date.';
  }
  if (!values[Fields.FromDate]) {
    errors[Fields.FromDate] = 'From Date must be set.';
  }
  if (moment(values[Fields.ToDate]).isBefore(moment(values[Fields.FromDate]))) {
    errors[Fields.ToDate] = 'To Date must be after From Date.';
  }
  if (!moment(values[Fields.ToDate]).isValid()) {
    errors[Fields.ToDate] = 'Enter a valid To Date.';
  }
  if (!values[Fields.ToDate]) {
    errors[Fields.ToDate] = 'To Date must be set.';
  }
  if (!values[Fields.LetterTypes].length) {
    errors[Fields.LetterTypes] = 'Letter Type must be set.';
  }
  return errors;
};

const mapStateToProps = state => {
  return {};
};

const LetterHistoryReportFreeAndReducedModeForm = reduxForm({
  form: LETTER_HISTORY_REPORT_FREE_AND_REDUCED_MODE_FORM_NAME,
  validate,
  enableReinitialize: false,
})(withRouter(connect(mapStateToProps, {})(LetterHistoryReportFormContainer)));

export default LetterHistoryReportFreeAndReducedModeForm;



// WEBPACK FOOTER //
// ./src/pages/letterhistoryreport/components/FreeAndReducedModeForm.js